import { useQuery } from "@tanstack/react-query";
import axiosRequest from "../axiosRequest";


export const useGetJob= (selectedCategory, search,id) => {
  return useQuery({
    queryKey: ["get-jobs", selectedCategory, search,id ], // ✅ Now depends on category & search
    queryFn: async () => {
      const formData = new FormData();
      formData.append("job_role", selectedCategory || ""); // Avoids undefined errors
      formData.append("search", search || "");
      formData.append("career_id", id || "");


      const response = await axiosRequest(
        "public/get-job-vacancy",
        "POST",
        formData,
        "multipart/form-data"
      );

      if (!response.data.status) {
        throw new Error(response.data.error || "Failed to fetch data");
      }
      return response.data;
    },
    onError: (error) => {
      console.error("Error fetching jobs:", error);
    },
    staleTime: 1000 * 60 * 10, // Cache for 10 min
    cacheTime: 1000 * 60 * 15, // Keep cache for 15 min
  });
};


// export const useGetJobs = (
//   currentPage,
//   pageSize,
//   searchTerm,
//   order,
//   orderBy
// ) => {
//   return useQuery({
//     queryKey: [
// "get-projects",
//   currentPage,
//   pageSize,
//   searchTerm,
//   order,
//   orderBy,
// ],
// queryFn: async () => {
//   const formData = new FormData();
//   formData.append("page", currentPage + 1);
//   formData.append("limit", pageSize);
//   formData.append("search", searchTerm);
//   formData.append("sort_by", orderBy);
//   formData.append("order_by", order);
//       const response = await axiosRequest(
//         "/get-job-vacancy",
//         "POST",
//         formData,
//         "multipart/form-data;"
//       );
//       if (!response.data.status) {
//         throw new Error(response.data.error || "Failed to fetch data");
//       }
//       return response.data.data;
//     },
//     onError: (error) => {
// //     },
//     staleTime: 1000 * 60 * 10,
//     cacheTime: 1000 * 60 * 15,
//   });
// };
export const useGetJobsDetail = (id) => {
  return useQuery({
    queryKey: ["get-jobs",id],
    queryFn: async () => {
      const formData = new FormData();
       formData.append("career_id",id);
      const response = await axiosRequest("public/get-job-vacancy", "POST", formData,
        "multipart/form-data;");
      if (!response.data.status) {
        throw new Error(response.data.error || "Failed to fetch data");
      }
      return response.data;
    },
    onError: (error) => {
    },
    staleTime: 1000 * 60 * 10,
    cacheTime: 1000 * 60 * 15,
    enabled:!!id
  });
};